var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('Spin',{attrs:{"fix":""}},[_c('Icon',{staticClass:"demo-spin-icon-load",attrs:{"type":"ios-loading","size":"35"}}),_c('div',[_vm._v("加载中，请稍后......")])],1):_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }